/* FOUNDATIONS 03 (Product Screens slide 5): one primary action per view,
 * everything else secondary or tertiary. Styles are the shared .btn* classes
 * in components.css, not redeclared here - tokens.css holds the variables those
 * classes read, not the classes themselves.
 */
import type { ButtonHTMLAttributes } from "react";

export type ButtonVariant = "primary" | "secondary" | "tertiary" | "destructive";
export type ButtonSize = "default" | "lg" | "dense";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export function Button({ variant = "secondary", size = "default", className, type = "button", ...rest }: ButtonProps) {
  const sizeClass = size === "lg" ? "btn--lg" : size === "dense" ? "btn--dense" : "";
  return (
    <button
      type={type}
      className={["btn", `btn--${variant}`, sizeClass, className].filter(Boolean).join(" ")}
      {...rest}
    />
  );
}
